import SemaphoreService from '@/services/semaphore.service.js'

const state = {
    orangeSemaphore : null
}

const getters = {
    getSogliaArancoione: (state) => {
        if(state.orangeSemaphore){
            return state.orangeSemaphore.QuantitaMassima;
        }
        return 0;
    }
}

const mutations = {
    setOrangeSemaphore: (state, sem) => {
        state.orangeSemaphore = sem;
    }
}

const actions = {
    getOrangeSemaphoreFromApi: ({commit}, data) => {
        return SemaphoreService.getSemaforoById(data.token, data.idSemaforo).then(
            (data) => {
                if(data){
                    commit('setOrangeSemaphore', data);
                    return true;
                }
                else{
                    return false;
                }
            }
        ).catch(
            error => {return false}
        );
    }
}


export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}